import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "pProgress",
  props: {
    progress: {
      default: 0,
      tyleof: [Number, String]
    }
  },
  computed: {
    ...walletVuex.mapState(["isMobile"])
  }
};